// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"672":"f5c949f1","729":"836d9967"}[chunkId] + ".chunk.css";
};